// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-weight-goal .weight-goal-description {
  padding: 12px;
  background-color: white;
  border: 1px solid var(--gray);
  border-radius: 8px;
  max-width: 264px;
  margin: 40px auto 16px;
}

.page-weight-goal .weight-goal-limit {
  padding: 12px;
  background-color: white;
  border: 1px solid var(--gray);
  border-radius: 8px;
  max-width: 264px;
  margin: 0 auto 16px;
}
.page-weight-goal .weight-goal-limit .text-with-icon-wrapper {
  align-items: center;
}

`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/weight-goal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".page-weight-goal .weight-goal-description {\n  padding: 12px;\n  background-color: white;\n  border: 1px solid var(--gray);\n  border-radius: 8px;\n  max-width: 264px;\n  margin: 40px auto 16px;\n}\n\n.page-weight-goal .weight-goal-limit {\n  padding: 12px;\n  background-color: white;\n  border: 1px solid var(--gray);\n  border-radius: 8px;\n  max-width: 264px;\n  margin: 0 auto 16px;\n}\n.page-weight-goal .weight-goal-limit .text-with-icon-wrapper {\n  align-items: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
